<img 
    [ngStyle]="{'height': height, 'padding-top': padding_top}"
    class="img-fluid" 
    [src]="getLogoTypeUrl()" 
    alt="logo"
/>